import Cookies from 'js-cookie';
import { readMeta } from './page';
import { PhotoStatus } from './constants/photo_status';

export function readDomainCookie(name: string): string | null {
  const d = readMeta('cookie_domain');
  if (d) return Cookies.get(name, { domain: d });
  return Cookies.get(name);
}

export function writeDomainCookie(name: string, value: string, options: any = {}) {
  const d = readMeta('cookie_domain');
  let optionsObject = options;
  if (d) optionsObject = { domain: d, ...options };
  if (Object.keys(optionsObject).length) Cookies.set(name, value, optionsObject);
  else Cookies.set(name, value);
}

export function setPhotoRejectCookie(photoStatus: string, name: string, value: string, days: number): boolean {
  if (photoStatus === PhotoStatus.REJECTED) {
    const photoCookie = readDomainCookie(name);
    if (photoCookie !== undefined) {
      return false;
    }
    if (photoCookie === undefined) {
      const currentTime = new Date();
      const result = new Date(currentTime);
      result.setDate(result.getDate() + days);

      writeDomainCookie(name, value, { expires: result });
    }
    return true;
  }
  return false;
}

export function deleteDomainCookie(name: string) {
  const d = readMeta('cookie_domain');
  if (d) Cookies.remove(name, { path: '/', domain: d });
  else Cookies.remove(name, { path: '/' });
}
